import script from "./BookingSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingSummary.vue?vue&type=script&setup=true&lang=ts"

import "./BookingSummary.vue?vue&type=style&index=0&id=484d38dd&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-rododo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484d38dd"]])

export default __exports__